import React from "react";
import { object } from "prop-types";
import { ResponsiveImage } from "@quintype/components";
import "./imagewithoutshare.m.css";
import { Link } from "@quintype/components";

function ImagewithCaptionWithoutShare({ element, story }) {
  return (
    <>
      <div styleName="wrapper">
        {element?.hyperlink ? (
          <Link href={element?.hyperlink}>
            <ResponsiveImage
              story={story}
              slug={decodeURIComponent(element["image-s3-key"])}
              metadata={element.metadata}
              widths={[420, 1040, 1600]}
              defaultWidth={1040}
              alt={story}
            />
          </Link>
        ) : (
          <ResponsiveImage
            story={story}
            slug={decodeURIComponent(element["image-s3-key"])}
            metadata={element.metadata}
            widths={[420, 1040, 1600]}
            defaultWidth={1040}
            alt={story}
          />
        )}
      </div>
      <div styleName="image-caption-wrapper">
        <span styleName="image-caption-text" dangerouslySetInnerHTML={{ __html: element.title }} />
        <span styleName="image-attribute" dangerouslySetInnerHTML={{ __html: element["image-attribution"] }} />
      </div>
    </>
  );
}

ImagewithCaptionWithoutShare.propTypes = {
  element: object,
  story: object
};

export default ImagewithCaptionWithoutShare;
